import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import es from '../../../../assets/i18n/es.json';
import { CasherService } from 'src/app/core/services/casher.service';
import { StoresService } from 'src/app/core/services/stores.service';
import { Subscription } from 'rxjs';
import { OrdersService } from 'src/app/core/services/orders.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  public productCategoryCollapsed = false;
  public ingredientCategoryCollapsed = false;
  public deliveryCompaniesCollapsed = false;
  public userCollapsed = false;
  public ordersCollapsed = false;
  public cashRegisterCollapsed = false;
  public uiBasicCollapsed = false;
  public samplePagesCollapsed = false;
  public bankReportsCollapsed = false;
  public deliveryCompanyListCollapse = false;
  public profileCollapsed = false;
  email: string;
  role: string;
  name: string;
  lastName: string;
  viewIcon = false;
  private observer: MutationObserver;
  roleSpanish = es;
  supervisor: boolean;
  storeId: number;
  storeSubscription;
  from: string | Date;
  to: string | Date;
  filterType: 'date' | 'number' = 'number';
  fromZ: number;
  toZ: number;

  constructor(private router: Router, private casherService: CasherService, private ordersService: OrdersService, private storesService: StoresService,
    private modalService: NgbModal,
    private toastrSvc: ToastrService,
    private http: HttpClient) { }

  ngOnInit() {
    const body = document.querySelector('body');
    this.email = localStorage.getItem("EMAIL");
    this.role = localStorage.getItem("ROLE");
    this.name = localStorage.getItem('NAME');
    this.lastName = localStorage.getItem('LASTNAME');
    if (this.casherService.getSupervisor != null) {
      this.supervisor = this.casherService.getSupervisor;
    } else {
      this.casherService.getCasherById(Number(localStorage.getItem('CASHIERID'))).subscribe((res) => {
        this.supervisor = res?.isSupervisor;
        localStorage.setItem('SUPERVISOR', res?.isSupervisor);
        this.casherService.setSupervisor(res?.isSupervisor);
      });
    }
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    document.querySelectorAll('.sidebar .nav-item').forEach(function (el) {
      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });

    const targetElement = document.querySelector('body');

    this.observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (targetElement.classList.contains('sidebar-icon-only')) {
            this.viewIcon = true;
          } else {
            this.viewIcon = false;
          }
        }
      }
    });

    this.observer.observe(targetElement, { attributes: true });


    this.storeSubscription = this.storesService.selectedStore$.subscribe(branchOffice => {
      if (branchOffice != null) {
        this.storeId = branchOffice;
      } else {
        this.storeId = null;
      }
    })
  }

  collapsedOrders() {
    if (this.ordersCollapsed) {
      this.ordersCollapsed = false;
    } else {
      this.ordersCollapsed = true;
    }

    if (this.router.url != '/orders/orders-carousel' && this.router.url != '/orders/add-order' && this.router.url != '/orders/all-orders-report') {
      this.router.navigate(['/orders/orders-carousel']);
    }
  }

  ngOnDestroy() {
    this.observer.disconnect();
    if (this.storeSubscription) {
      this.storeSubscription.unsubscribe();
    }
  }

  logout(): void {
    localStorage.removeItem('ACCESS_TOKEN');
    localStorage.removeItem('EMAIL');
    localStorage.removeItem('ROLE');
    localStorage.removeItem('STOREID');
    localStorage.removeItem('STORE');

    localStorage.clear();
    this.router.navigate(['/user-pages/login']);
  }

  addOrderSumary() {
    localStorage.setItem('products', JSON.stringify([]));
    localStorage.setItem('totalOrder', "0");
    localStorage.setItem('subTotalOrder', "0");
    this.router.navigate(['/orders/add-order-sumary']);
  }

  printReportX() {
    if (this.storeId != null) {
      const reference = this.formatReference(new Date(), 1);

      const reportZ = {
        "Cmd": 2,
        "Reference": reference,
        "ReportData": { "Rpte": "x", "From": null, "To": null, "OutPutType": 1 }
      }
      this.ordersService.printReportZ(reportZ, this.storeId).subscribe((res) => {
        if (res.success) {
          if (res?.printerLocal) {
            this.sendToLocalPrinter(res, `Reporte X impreso con exito`);
          } else {
            this.toastrSvc.success(`Reporte X impreso con exito`, `Operación exitosa`);
          }
        } else {
          this.toastrSvc.error(`No esta configurada la impresora para el reporte X.`, `Operación fallida`, { disableTimeOut: true, closeButton: true });
        }
      }, (error) => {
        console.error('Error al imprimir factura:', error);
        if (error.status == 500) {
          this.toastrSvc.error(`Tiempo de espera agotado al imprimir el reporte X, si persiste contacte con el soporte. (500)`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
        } else if (error.status == 503) {
          this.toastrSvc.error(`No fue posible comunicarse con la impresora para el reporte X, si persiste contacte con el soporte. (503)`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
        } else if (error.status == 504) {
          this.toastrSvc.error(`No fue posible comunicarse con la impresora para el reporte X, si persiste contacte con el soporte. (504)`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
        } else if (error.status == 408) {
          this.toastrSvc.error(`No fue posible comunicarse con la impresora para el reporte X, si persiste contacte con el soporte. (408)`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
        } else {
          if (error.error.message != undefined) {
            this.toastrSvc.error(error.error.message + ", si persiste contacte con el soporte.", `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
          } else {
            this.toastrSvc.error(`No puede comunicarse con la impresora para el reporte X, si persiste contacte con el soporte.`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
          }
        }
      });
    }
  }

  printReportZ() {
    if (this.storeId != null) {
      const reference = this.formatReference(new Date(), 0);

      const reportZ = {
        "Cmd": 2,
        "Reference": reference,
        "ReportData": { "Rpte": "z", "From": null, "To": null, "OutPutType": 1 }
      }
      this.ordersService.printReportZ(reportZ, this.storeId).subscribe((res) => {
        if (res.success) {
          if (res?.printerLocal) {
            this.sendToLocalPrinter(res, `Reporte Z impreso con exito`);
          } else {
            this.toastrSvc.success(`Reporte Z impreso con exito`, `Operación exitosa`);
          }
        } else {
          this.toastrSvc.error(`No esta configurada la impresora para el reporte Z.`, `Operación fallida`, { disableTimeOut: true, closeButton: true });
        }
      }, (error) => {
        console.error('Error al imprimir factura:', error);
        if (error.status == 500) {
          this.toastrSvc.error(`Tiempo de espera agotado al imprimir el reporte Z, si persiste contacte con el soporte. (500)`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
        } else if (error.status == 503) {
          this.toastrSvc.error(`No fue posible comunicarse con la impresora para el reporte Z, si persiste contacte con el soporte. (503)`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
        } else if (error.status == 504) {
          this.toastrSvc.error(`No fue posible comunicarse con la impresora para el reporte Z, si persiste contacte con el soporte. (504)`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
        } else if (error.status == 408) {
          this.toastrSvc.error(`No fue posible comunicarse con la impresora para el reporte Z, si persiste contacte con el soporte. (408)`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
        } else {
          if (error.error.message != undefined) {
            this.toastrSvc.error(error.error.message + ", si persiste contacte con el soporte.", `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
          } else {
            this.toastrSvc.error(`No puede comunicarse con la impresora para el reporte Z, si persiste contacte con el soporte.`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
          }
        }
      });
    }
  }

  formatDateReportZ(date: string | Date): string {
    let d: Date;

    if (typeof date === 'string') {
      // Para strings, dividimos la fecha en partes y creamos la fecha manualmente
      const [year, month, day] = date.split('-').map(Number);
      d = new Date(year, month - 1, day); // Los meses en JS van de 0 a 11
    } else {
      d = new Date(date);
    }

    const yearStr = String(d.getFullYear()).slice(-2);
    const monthStr = String(d.getMonth() + 1).padStart(2, '0');
    const dayStr = String(d.getDate()).padStart(2, '0');

    return `${dayStr}${monthStr}${yearStr}`; // Formato DDMMYY
  };

  formatReference(date: string | Date, identifier: 0 | 1 | 2 | 3): string {
    let d: Date;

    if (typeof date === 'string') {
      // Si llega un string en formato YYYY-MM-DD
      const [year, month, day] = date.split('-').map(Number);
      d = new Date(year, month - 1, day);
    } else {
      d = new Date(date);
    }

    const yearStr = String(d.getFullYear()).slice(-2);
    const monthStr = String(d.getMonth() + 1).padStart(2, '0');
    const dayStr = String(d.getDate()).padStart(2, '0');
    const hoursStr = String(d.getHours()).padStart(2, '0');
    const minutesStr = String(d.getMinutes()).padStart(2, '0');

    return `${yearStr}${monthStr}${dayStr}${hoursStr}${minutesStr}${identifier}`;
  }

  printReportHistoryZ(modal) {
    let fromVal;
    let toVal;
    let rpteCode = 'rzf';
    let reference;

    if (this.filterType === 'date') {
      if (!this.from || !this.to) {
        this.toastrSvc.error(`Debe seleccionar una fecha de inicio y una fecha de fin.`, `Operación fallida`, { disableTimeOut: true, closeButton: true });
        return;
      }
      fromVal = this.formatDateReportZ(this.from);
      toVal = this.formatDateReportZ(this.to);
      rpteCode = 'rzf';
      reference = this.formatReference(new Date(), 2); // Fecha actual para la referencia
    } else {
      if (this.fromZ == null || this.toZ == null) {
        this.toastrSvc.error(`Debe ingresar un número de inicio y un número de fin.`, `Operación fallida`, { disableTimeOut: true, closeButton: true });
        return;
      }
      fromVal = this.fromZ.toString();
      toVal = this.toZ.toString();
      rpteCode = 'rz'; // rz para Reporte Z por Número
      reference = this.formatReference(new Date(), 3); // Fecha actual para la referencia
    }

    const reportZ = {
      "Cmd": 2,
      "Reference": reference,
      "ReportData": { "Rpte": rpteCode, "From": fromVal, "To": toVal, "OutPutType": 1 }
    }
    this.ordersService.printReportZ(reportZ, this.storeId).subscribe((res) => {
      modal.close();
      if (res.success) {
        if (res?.printerLocal) {
          this.sendToLocalPrinter(res, `Reporte historico Z impreso con exito`);
        } else {
          this.toastrSvc.success(`Reporte historico Z impreso con exito`, `Operación exitosa`);
        }
      } else {
        this.toastrSvc.error(`No esta configurada la impresora para el reporte historico Z.`, `Operación fallida`, { disableTimeOut: true, closeButton: true });
      }
    }, (error) => {
      console.error('Error al imprimir factura:', error);
      if (error.status == 500) {
        this.toastrSvc.error(`Tiempo de espera agotado al imprimir el reporte historico Z, si persiste contacte con el soporte. (500)`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
      } else if (error.status == 503) {
        this.toastrSvc.error(`No fue posible comunicarse con la impresora para el reporte historico Z, si persiste contacte con el soporte. (503)`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
      } else if (error.status == 504) {
        this.toastrSvc.error(`No fue posible comunicarse con la impresora para el reporte historico Z, si persiste contacte con el soporte. (504)`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
      } else if (error.status == 408) {
        this.toastrSvc.error(`No fue posible comunicarse con la impresora para el reporte historico Z, si persiste contacte con el soporte. (408)`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
      } else {
        if (error.error.message != undefined) {
          this.toastrSvc.error(error.error.message + ", si persiste contacte con el soporte.", `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
        } else {
          this.toastrSvc.error(`No puede comunicarse con la impresora para el reporte historico Z, si persiste contacte con el soporte.`, `Comunicación con la impresora`, { disableTimeOut: true, closeButton: true });
        }
      }
    });
  }

  formatDateForInput(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  async openMediumModal(mediumModalContent) {
    const today = new Date();
    this.from = this.formatDateForInput(today);
    this.to = this.formatDateForInput(today);
    this.filterType = 'number';
    this.fromZ = null;
    this.toZ = null;

    this.modalService.open(mediumModalContent, {
      backdrop: 'static', // No se cierra al hacer click fuera
      keyboard: false     // No se cierra con ESC
    });
  }

  sendToLocalPrinter(res: any, message: string) {
    const url = res.printerLocalUrl;
    const data = res.request;

    this.http.post(url, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).subscribe({
      next: (response) => {
        const reference = data.Reference;
        if (reference) {
          this.checkPrinterStatus(url, reference, message, 0);
        } else {
          this.toastrSvc.success(message, `Operación exitosa`); // Fallback
        }
      },
      error: (error) => {
        console.error('Error enviando a impresora local:', error.message);
        this.toastrSvc.error(`No fue posible comunicarse con la impresora, si persiste contacte con el soporte.`, `Error de comunicación`, { disableTimeOut: true, closeButton: true });
      }
    });
  }

  checkPrinterStatus(url: string, reference: string, message: string, attempts: number) {
    if (attempts >= 30) {
      this.toastrSvc.error(`Tiempo de espera agotado al imprimir, si persiste contacte con el soporte.`, `Error de comunicación`, { disableTimeOut: true, closeButton: true });
      return;
    }

    const payload = {
      Cmd: 5,
      Reference: reference
    };

    this.http.post(url, payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).subscribe({
      next: (response: any) => {
        if (response.CodeResponse === 3) {
          this.toastrSvc.success(message, `Operación exitosa`);
        } else if (response.CodeResponse === 4) {
          const errorMsg = response.ErrorDescription || response.Description || "Error en la impresión";
          this.toastrSvc.error(errorMsg + `, contacte con el soporte.`, `Error de comunicación`, { disableTimeOut: true, closeButton: true });
        } else if (response.CodeResponse === 2) {
          setTimeout(() => {
            this.checkPrinterStatus(url, reference, message, attempts + 1);
          }, 2000);
        } else {
          const unknownMsg = response.ErrorDescription || response.Description || "Respuesta desconocida de la impresora";
          this.toastrSvc.error(unknownMsg + `, contacte con el soporte.`, `Error de comunicación`, { disableTimeOut: true, closeButton: true });
        }
      },
      error: (error) => {
        console.error('Error enviando a impresora local en consulta de estatus:', error.message);
        this.toastrSvc.error(`No fue posible comunicarse con la impresora, si persiste contacte con el soporte.`, `Error de comunicación`, { disableTimeOut: true, closeButton: true });
      }
    });
  }

}
